import React from 'react';
import { Box, Typography, Container, Paper, Divider } from '@mui/material';

const Terms = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Terms and Conditions
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Last Updated: April 11, 2026
        </Typography>
        
        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          1. Acceptance of Terms
        </Typography>
        <Typography variant="body1" paragraph>
          By registering for and using Hostly Inn, you agree to be bound by these terms. If you do not agree, please do not use the system.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          2. Hostel Rules
        </Typography>
        <Typography variant="body1" paragraph>
          Students must adhere to the check-in/check-out times and use the QR-based gate management system for every entry and exit.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          3. Payment Terms
        </Typography>
        <Typography variant="body1" paragraph>
          Rent must be paid through the official payment gateway (PhonePe). Late payments may incur fees as specified in the hostel manual.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          4. User Conduct
        </Typography>
        <Typography variant="body1" paragraph>
          Any misuse of the digital complaint system or providing false Aadhar information will lead to immediate disciplinary action.
        </Typography>
        
        <Divider sx={{ my: 4 }} />
        <Typography variant="body2" color="text.secondary" align="center">
          © 2026 Hostly Inn. All rights reserved.
        </Typography>
      </Paper>
    </Container>
  );
};

export default Terms;
